<template>
  <div class="detial">
    <div class="img" :style="{height:bannerHeight+'px'}" >
      <img
      ref="bannerHeight"
      @load="imgLoad"
      style="display: block; width: 100%;height: 100%;"
      :src="banner"
      alt=""
      />
    </div>
    <div class="content">
      <div class="wrapper">
        <div class="scene">
          <p class="title">解决方案</p>
          <ul>
            <li
              class="list"
              v-for="(item, index) in list"
              :key="index"
              @mouseover="showMask(index)"
              @mouseleave="noMask"
              @click="goMore(item.id)"
            >
              <img :src="item.img" alt="" />
              <div
                class="bottom"
                v-if="
                  active == -1
                    ? !isShowMask
                    : index == active
                    ? !isShowMask
                    : isShowMask
                "
              >
                {{ item.name }}
              </div>
              <div
                class="mask"
                :class="{ isShowMask1: index == active }"
                v-else
              >
                <p>{{ item.name }}</p>
                <div>
                  {{ item.desc }}
                </div>
                <div class="more">>>>更多</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { baseUrl } from "../api/index";
export default {
  data() {
    return {
      active: -1,
      isShowMask: false,
      sceneList: [],
      goodsList: [],
      img: "",
      list: [],
      banner: "",
      detialList: [],
      bannerHeight: "",
    };
  },
  created() {
    this.getCategoryInfo({ mid: 4 });
  },
  mounted() {
    this.imgLoad();
    window.addEventListener(
      "resize",
      () => {
        this.imgLoad();
      },
      false
    );
  },
  methods: {
    imgLoad() {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height;
      });
    },
    showMask(index) {
      this.active = index;
      this.isShowMask = true;
    },
    noMask() {
      this.active = -1;
      this.isShowMask = false;
    },
    ...mapMutations("solution", ["setImg","setName","setDesc","setInfo"]),
    goMore(id){
      this.list.forEach((ele)=>{
        if (ele.id==id) {
          this.setImg(ele.banner)
          this.setName(ele.name)
          this.setDesc(ele.desc)
          this.setInfo(ele.info)
        }
      })
      this.$router.push("/detial/"+id)
    },
    async getCategoryInfo(params) {
      let res = await this.$api.getCategoryInfo(params);
      this.list = res.data.data.category_info;
      this.list.forEach((ele) => {
        ele.img = baseUrl + ele.img;
        ele.banner=baseUrl + ele.banner
      });
      this.banner = baseUrl + res.data.data.menu_info.banner;
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 1200px) {
  .detial {
  .img {
    position:relative;
  //   width: 100%;
  //   height: 4.6rem;
  //   img {
  //     width: 100%;
  //     height: 100%;
    // }
  }
  .content {
    margin-top: 0.5rem;
    .wrapper {
      text-align: center;
      width: 12rem;
      margin: 0 auto;
      color: rgb(227, 233, 238);
      .scene {
        font-size: 0.3rem;
        .title {
          position: relative;
          color: #333;
          font-weight: bold;
          font-size: 36px;
          margin-top: 50px;
          &::after {
            position: absolute;
            // top: 0.5rem;
            top: 0.56rem;
            left: 6rem;
            margin-left: -0.3rem;
            content: "";
            display: inline-block;
            height: 8px;
            width: 60px;
            border-radius: 5px;
            background: linear-gradient(90deg, #3f66f5, #009fff);
          }
        }
        ul {
          display: flex;
          flex-wrap: wrap; //---------------
          margin-top: 0.75rem;
          li:nth-child(3n) {
            margin-right: 0;
          }
          .list {
            position: relative;
            width: 3.5rem;
            height: 4.3rem;
            margin-right: 0.75rem;
            margin-bottom: 30px; //---------------
            overflow: hidden;
            box-shadow: 10px 10px 10px 0px rgb(0 0 0 / 6%);
            cursor: pointer; 
            img {
              width: 100%;
              height: 100%;
            }
            .bottom {
              position: absolute;
              bottom: 0;
              width: 100%;
              height: 0.8rem;
              line-height: 0.8rem;
              color: #fff;
              font-size: 20px;
              background-color: rgb(0 0 0 / 25%);
            }
            // 遮罩层
            .mask {
              width: 100%;
              height: 100%;
              // background-color: pink;
              position: absolute;
              left: 0;
              top: 4.3rem;
              right: 0;
              text-align: left;
              padding-left: 10px;
              padding-top: 0.8rem;
              padding-right: 10px;
              padding-bottom: 10px;
              box-sizing: border-box;
              .more{
                margin-top: 20px;
                font-size: 18px;
                text-align: center;
              }
              p {
                text-align: center;
                font-size: 0.2rem;
                margin-bottom: 0.1rem;
              }
              div {
                font-size: 0.14rem;
                line-height: 0.24rem;
                width: 100px;
                // height: 200px;
                // background-color: pink;
                width: 330px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 5;
              }
            }
            .isShowMask1 {
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              // background-color: hwb(0 3% 97% / 0.317) ;
              background-color: rgba(0, 0, 0, 0.2);
              transition: all 1s;
              padding-bottom: 20px;
            }
          }
          li:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}

}

@media screen and (max-width: 750px) {
  .detial {
  .img {
    position: relative;
    // width: 100%;
    // height: 1.5rem;
    // img {
    //   width: 100%;
    //   height: 100%;
    // }
  
  }
  .content {
    min-height: 3.5rem;
    .wrapper {
      text-align: center;
      width: 3.2rem;
      margin: 0 auto;
      color: rgb(227, 233, 238);
      .scene {
        font-size: 0.3rem;
        text-align: center;
        .title {
          position: relative;
          color: #333;
          font-weight: bold;
          font-size: 0.12rem;
          margin-top: 0.1rem;
          &::after {
          position: absolute;
          top: 0.2rem;
          left: 1.75rem;
          margin-left: -0.3rem;
          content: "";
          display: inline-block;
          height: 0.04rem;
          width: 0.3rem;
          border-radius: 0.025rem;
          background: linear-gradient(90deg, #3f66f5, #009fff);
          }
        }
        ul {
          display: flex;
          flex-wrap: wrap; //---------------
          margin-top: 0.18rem;
          .list {
            position: relative;
            width: 1.5rem;
            height: 1.5rem;
            margin-right: 0.1rem;
            margin-bottom: 0.15rem; //---------------
            overflow: hidden;
            box-shadow: 10px 10px 10px 0px rgb(0 0 0 / 6%);
            cursor: pointer; 
            img {
              width: 100%;
              height: 100%;
            }
            .bottom {
              position: absolute;
              bottom: 0;
              width: 100%;
              height: 0.35rem;
              line-height: 0.35rem;
              color: #fff;
              background-color: rgb(0 0 0 / 25%);
              font-size: 0.09rem;
            }
            // 遮罩层
            .mask {
              width: 100%;
              height: 100%;
              // background-color: pink;
              position: absolute;
              left: 0;
              top: 4.3rem;
              right: 0;
              text-align: left;
              padding-left: 0.1rem;
              padding-top: 0.8rem;
              padding-right: 0.1rem;
              padding-bottom: 0.1rem;
              box-sizing: border-box;
              .more{
                margin-top: 0.2rem;
                font-size: 0.18rem;
                text-align: center;
              }
              p {
                text-align: center;
                font-size: 0.3rem;
                margin-bottom: 0.1rem;
              }
              div {
                font-size: 0.14rem;
                line-height: 0.24rem;
                width: 1rem;
                // height: 200px;
                // background-color: pink;
                width: 3.3rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 5;
              }
            }
            .isShowMask1 {
              // width: 100%;
              // height: 100%;
              // position: absolute;
              // left: 0;
              // top: 0;
              // right: 0;
              // bottom: 0;
              // // background-color: hwb(0 3% 97% / 0.317) ;
              // background-color: rgba(0, 0, 0, 0.2);
              // transition: all 1s;
              // padding-bottom: 20px;
              display: none;
            }
          }
          li:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}

}

</style>